import { useCallback, useRef } from 'react';

// Starting a request returns a check that stays true only until another request starts, so stale answers are dropped.
export const useLatestRequest = () => {
  const latestRequestId = useRef(0);

  return useCallback(() => {
    const requestId = ++latestRequestId.current;
    return () => requestId === latestRequestId.current;
  }, []);
};
